import Lottie from 'lottie-react'

type LottieAnimationProps = {
  animationData: object
  height?: number | string
  width?: number | string
}

const LottieAnimation = ({ animationData, height, width }: LottieAnimationProps) => {
  const style: React.CSSProperties = {
    height: height ?? '100%',
    width: width ?? '100%',
  }

  return (
    <Lottie
      animationData={animationData}
      loop={true}
      autoplay={true}
      style={style}
      rendererSettings={{
        preserveAspectRatio: 'xMidYMid meet',
      }}
    />
  )
}

export default LottieAnimation
